export default __webpack_public_path__ + "static/media/architecture-menu-img.40757e1e.jpg";